import axios from 'axios';
import { authErrorMessage } from '@/features/auth/error-message';
import { ApiShapeError } from '@/lib/task-api';
import { ADMIN_ERROR_MESSAGE_KEYS } from './labels';

/**
 * Platform yonetimi hatasi -> KULLANICIYA GOSTERILEBILIR metin.
 *
 * UC AYRI KAYNAK, UC AYRI DAVRANIS:
 *
 *   1. ApiShapeError  -> "yaniti anlayamadim". Bu bir SUNUCU HATASI DEGIL,
 *      istemci-sunucu sozlesmesinin ayrismasi. Kullaniciya "kayit yok" demek
 *      YANLIS olurdu; ayri bir metin ve TEKRAR DENE secenegi hak ediyor.
 *   2. HTTP 4xx / zarf hatasi -> sunucu sabit bir KOD yaziyor
 *      ('CANNOT_MODIFY_SELF'). Kodu oldugu gibi basmak hicbir sey anlatmaz;
 *      once tabloya bakilir.
 *   3. Tablonun tutmadigi her sey -> `authErrorMessage`. Ag hatasi, 429 (duyuru
 *      ucu IP basina 15 dakikada 10 istekle sinirli) ve "sunucu zaten Turkce
 *      yaziyor" durumlari orada TEK yerde cozulmus; ikinci bir kopya ikisinin
 *      ayrismasi demek olurdu.
 */
export const adminErrorMessage = (error: unknown, t: (key: string) => string): string => {
  // ApiShapeError da bir Error — bu kontrol authErrorMessage'in Turkce
  // teknik metnini basmasindan ONCE gelmek ZORUNDA.
  if (error instanceof ApiShapeError) return t('admin.errors.badShape');

  const raw = rawServerCode(error);
  const key = raw === null ? undefined : ADMIN_ERROR_MESSAGE_KEYS[raw];
  if (key !== undefined) return t(key);
  return authErrorMessage(error, t);
};

/**
 * Sunucunun yazdigi kodu cikarir.
 *
 * HTTP 400'de axios firlatir ve kod govdededir. HTTP 200 + `code: 'error'`
 * durumunda `unwrap` bir ApiError firlatir ve SUNUCU KODU onun MESAJIDIR
 * (ApiError.code alani zarf `code`u, yani 'error' olur — bakilacak yer mesaj).
 */
const rawServerCode = (error: unknown): string | null => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: unknown } | undefined;
    return typeof data?.message === 'string' ? data.message : null;
  }
  if (error instanceof Error) return error.message;
  return null;
};
